import React from 'react';
import { List, Datagrid, TextField, DateField, TextInput, Filter, SelectInput } from 'react-admin';
import { CustomPagination, BulkDeleteButtonDisable } from './utils';

const StripeCustomersFilter = props => (
    <Filter {...props}>
        <SelectInput
            label="Поле"
            source="field"
            choices={[
                { id: 'id', name: 'Id' },
                { id: 'profile_id', name: 'Id пользователя' },
                { id: 'stripe_id', name: 'Id в Stripe' },
                { id: 'payment_method', name: 'Платежный метод' },
                { id: 'created', name: 'Время создания' },
                { id: 'updated', name: 'Последнее обновление' },
            ]}
            alwaysOn
        />
        <TextInput
            label="Поиск"
            source="q"
            alwaysOn
        />
    </Filter>
);

export const StripeCustomersList = props => (
    <List
        {...props}
        filters={<StripeCustomersFilter />}
        bulkActionButtons={<BulkDeleteButtonDisable />}
        pagination={<CustomPagination />}
    >
        <Datagrid rowClick="edit">
            <TextField
                label="Id"
                source="id"
            />
            <TextField
                label="Id пользователя"
                source="profile_id"
            />
            <TextField
                label="Id в Stripe"
                source="stripe_id"
            />
            <TextField
                label="Платежный метод"
                source="payment_method"
            />
            <DateField
                label="Время создания"
                source="created"
                showTime
                locales="ru-RU"
            />
            <DateField
                label="Последнее обновление"
                source="updated"
                showTime
                locales="ru-RU"
            />
        </Datagrid>
    </List>
);
